import styled from 'styled-components';

export { ReactComponent as MoreIcon } from 'Images/icon-action-bar-more.svg';

export const Wrapper = styled.div`
`;
Wrapper.displayName = 'Wrapper';
